// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bOpnG","titleContainer":"styles_titleContainer__4YHlL","title":"styles_title__9Mt0I","list":"styles_list__vyLOL","progress":"styles_progress__8X50m"};